export const tr = {
    'selected-groups-count': {
        one: '{count} kategori seçildi',
        some: '{count} kategori seçildi',
        many: '{count} kategori seçildi',
        none: 'Kategori seçimi'
    },
    'video-preview-header': 'Önizleme',
    'video-title': 'Ses kayıtların arşivi'
};
